import { Box, ListItem, Text } from '@domain-group/suit-theme'

import type { TaskListTemplateItemModel } from '@models/types'

interface TaskListTemplateItemProps {
  taskListTemplateItem: TaskListTemplateItemModel,
}

const TaskListTemplateItem = (props: TaskListTemplateItemProps) => {
  const { taskListTemplateItem: { description, title } } = props

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        as: 'a',
        borderBottom: '1px dashed',
        fontSize: 'small',
        paddingY: 'large',
      }}
      disableHover
    >
      <Box alignItems="center">
        <Box flexDirection="column">
          <Text variant="ellipsis">{title}</Text>

          {description && (
            <Text
              color="bodyFontLightColor"
              display={['none', 'block']}
              lineHeight={1.3}
              fontSize="xsmall"
              marginTop="small"
            >
              {description}
            </Text>
          )}
        </Box>
      </Box>
    </ListItem>
  )
}

export default TaskListTemplateItem
